export var IProductInformationSection;
(function (IProductInformationSection) {
    let Format;
    (function (Format) {
        Format["FORMAT_UNKNOWN"] = "FORMAT_UNKNOWN";
        Format["BULLET_LIST"] = "BULLET_LIST";
        Format["LINE_BREAKS"] = "LINE_BREAKS";
    })(Format = IProductInformationSection.Format || (IProductInformationSection.Format = {}));
    let Type;
    (function (Type) {
        Type["TYPE_UNKNOWN"] = "TYPE_UNKNOWN";
        Type["DESCRIPTION"] = "DESCRIPTION";
        Type["DETAILS"] = "DETAILS";
        /**
         * @deprecated
         */
        Type["INGREDIENTS"] = "INGREDIENTS";
        /**
         * @deprecated
         */
        Type["CONTAINS"] = "CONTAINS";
        Type["SAFETY_INFORMATION"] = "SAFETY_INFORMATION";
        Type["ECO_FRIENDLY"] = "ECO_FRIENDLY";
    })(Type = IProductInformationSection.Type || (IProductInformationSection.Type = {}));
    let IOptionLevelEntries;
    (function (IOptionLevelEntries) {
        /**
         * Return an instance of IOptionLevelEntries with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IOptionLevelEntries.build = (partial) => (Object.assign({ entries: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(IOptionLevelEntries = IProductInformationSection.IOptionLevelEntries || (IProductInformationSection.IOptionLevelEntries = {}));
    let IAttributeDetail;
    (function (IAttributeDetail) {
        let AttributeIcon;
        (function (AttributeIcon) {
            AttributeIcon["ATTRIBUTE_ICON_UNKNOWN"] = "ATTRIBUTE_ICON_UNKNOWN";
            AttributeIcon["SPROUT"] = "SPROUT";
            AttributeIcon["RESPONSIBLE_CONSUMPTION_AND_PRODUCTION"] = "RESPONSIBLE_CONSUMPTION_AND_PRODUCTION";
            AttributeIcon["SHARE_HEART"] = "SHARE_HEART";
        })(AttributeIcon = IAttributeDetail.AttributeIcon || (IAttributeDetail.AttributeIcon = {}));
        let IAttributeValue;
        (function (IAttributeValue) {
            /**
             * Return an instance of IAttributeValue with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IAttributeValue.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
        })(IAttributeValue = IAttributeDetail.IAttributeValue || (IAttributeDetail.IAttributeValue = {}));
        /**
         * Return an instance of IAttributeDetail with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IAttributeDetail.build = (partial) => (Object.assign({ attribute_values: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(IAttributeDetail = IProductInformationSection.IAttributeDetail || (IProductInformationSection.IAttributeDetail = {}));
    let ILink;
    (function (ILink) {
        /**
         * Return an instance of ILink with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ILink.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(ILink = IProductInformationSection.ILink || (IProductInformationSection.ILink = {}));
    /**
     * Return an instance of IProductInformationSection with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IProductInformationSection.build = (partial) => (Object.assign({ section_entries: [], entries: [], product_option_level_entries: {}, attribute_details: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IProductInformationSection || (IProductInformationSection = {}));
